export const POST_CANCEL_SUBSCRIPTION_REQUEST='cancelSubscriptionReducer/POST_CANCEL_SUBSCRIPTION_REQUEST'
export const POST_CANCEL_SUBSCRIPTION_SUCCESS='cancelSubscriptionReducer/POST_CANCEL_SUBSCRIPTION_SUCCESS'
export const POST_CANCEL_SUBSCRIPTION_FAILED='cancelSubscriptionReducer/POST_CANCEL_SUBSCRIPTION_FAILED'